import { readable, writable } from 'svelte/store';

// screen sizes
//export const sizes = readable( {tablet: '850px', phone: '450px'} );

// THEME - persistent
const storedTheme = localStorage.getItem("theme")||'light';
export const theme = writable(storedTheme);
theme.subscribe(value => {
    localStorage.setItem("theme", value === 'dark' ? 'dark' : 'light');
});